export default function StatusBadge({ status }) {
  const tone =
    {
      Scheduled: "info",
      Preparing: "warning",
      "Out for Delivery": "primary",
      Delivered: "success",
      Cancelled: "danger",
      Skipped: "secondary",
      Active: "success",
      active: "success",
      Paused: "warning",
      paused: "warning",
      cancelled: "danger",
    }[status] || "secondary";
  return <span className={`badge text-bg-${tone} rounded-pill`}>{status}</span>;
}
